module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("5 Minutes With Jesus: Quiet Time for Your Soul")]), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "AC-cb"
    }
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1.jpg",
      "src": "images/himg-6-1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pz10-2"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/contents#ba_06",
      "id": "ab_06"
    }
  }, [_vm._v("The Lord Is Our Protector")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pAFJ"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("P")]), _vm._v("arents can be pretty intense when it comes to protecting their kids.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-4"
    }
  }, [_vm._v("When children are tiny, it is all about babyproofing—setting up gates in front of stairs, putting guards on sharp corners, and locking cabinets filled with cleaning supplies.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-5"
    }
  }, [_vm._v("Then the children get a little older, and parents frantically say a lot of the same phrases over and over: “Look both ways before you cross the street!” “Do you have your coat?” “Don’t talk to strangers!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-6"
    }
  }, [_vm._v("A few more years pass, and moms and dads find themselves having hard conversations about texting and driving, safe dating, and on and on and on . . .")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-7"
    }
  }, [_vm._v("I am not sure a parent ever stops being concerned about a child’s safety.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz10-8"
    }
  }, [_vm._v("Have you ever thought about the truth that your heavenly Father wants to keep you, His child, safe too? Matthew 2 tells us about just such a time. Jesus was still young, "), _c('span', {
    attrs: {
      "id": "z11-1"
    }
  }, [_vm._v("probably a toddler, when His earthly father, Joseph, received an urgent warning from God in a dream. ")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-2"
    }
  }, [_vm._v("“Get up,” he said, “take the child and his mother and escape to Egypt. Stay there until I tell you, for Herod is going to search for the child to kill him” (vv. 13–14).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-3"
    }
  }, [_vm._v("I wonder how Joseph felt when those urgent words interrupted his dreams. The angel’s appearance—and message—must have been terrifying!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-4"
    }
  }, [_vm._v("Jesus’ very life depended on Joseph’s willingness to listen and obey, and Joseph did not hesitate. Matthew 2:14 tells us he got up and took his family to safety that very night.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-5"
    }
  }, [_vm._v("Just as Joseph loved and protected his son, God loves you and wants to keep you safe. He might speak to you urgently in a dream as He spoke to Joseph, but more often He speaks gently and softly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-6"
    }
  }, [_vm._v("One of the greatest gifts of spending time in quiet listening to God is getting to know His voice. Being able to recognize it opens the way for Him to speak into our lives and keep us from harm. Sometimes He will keep us from physical harm, but He seeks to keep us safe in so many other ways as well.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-7"
    }
  }, [_vm._v("As a loving Father, He might warn us away from a toxic relationship or hold up a stop sign concerning a major life change. But one of the beautiful things about our Savior is that He also cares about "), _c('span', {
    attrs: {
      "id": "z12-1"
    }
  }, [_vm._v("the small things in our lives, about the habits that harm us and the old wounds that make us vulnerable. ")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz12-2"
    }
  }, [_vm._v("When I was young, I didn’t always go along with my mother’s attempts to protect me. Now that I am older, I hope I am wiser. I want to follow Joseph’s example by listening closely to my loving Father’s words of protection in my life.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz12-3"
    }
  }, [_vm._v("Like Joseph, may we never hesitate to obey!")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "pz12-4"
    }
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('b', [_c('i', [_vm._v("Today I will listen for the Lord’s voice and trust that He is watching over me.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center2",
    attrs: {
      "id": "pz12-5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-8-1.jpg",
      "src": "images/himg-8-1.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Five Minutes in the Word")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images/himg-8-2.jpg",
      "src": "images/himg-8-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz12-6"
    }
  }, [_c('i', [_vm._v("The Lord is faithful, and he will strengthen you and protect you from the evil one.")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "pz12-8"
    }
  }, [_vm._v("2 Thessalonians 3:3")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz12-9"
    }
  }, [_c('i', [_vm._v("The sun will not harm you by day, nor the moon by night.")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "pz12-10"
    }
  }, [_vm._v("Psalm 121:6")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pAXN"
    }
  }, [_c('i', [_vm._v("If you say, “The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" is my refuge,” and you make the Most High your dwelling, no harm will overtake you, no disaster will come near your tent.")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "Aop"
    }
  }, [_vm._v("Psalm 91:9–10")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "AqE"
    }
  }, [_c('i', [_vm._v("The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" will keep you from all harm—he will watch over your life.")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "Asg"
    }
  }, [_vm._v("Psalm 121:7")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "At0s"
    }
  }, [_c('i', [_vm._v("The waywardness of the simple will kill them, and the complacency of fools will destroy them; but whoever listens to me will live in "), _c('span', {
    attrs: {
      "id": "pz14-1"
    }
  }, [_vm._v("safety")]), _vm._v(" and be at ease, without fear of harm.")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "pz13-3"
    }
  }, [_vm._v("Proverbs 1:32–33")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b78f8768","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter06.vue
// module id = 75
// module chunks = 0